import { SbpDefaultOutModel } from "../../models/settings/sbpDefaultOutModel";
import { inject, injectable } from "inversify";
import IAlertService from "../alert/IAlertService";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";
import BaseOperationService from "../operations/BaseOperationService";
import { PersonStore } from "../../store/modules/person";
import { ConfigStore } from "../../store/modules/config";
import i18n from "@/i18n";
import { OperationRequestData } from "../../data/operationRequestData";
import { OperationsApi } from "../api/OperationsApi";
import { RequestsStates } from "../../data/enums/requestsStates";
import { ActionStateEnum } from "../../models/enums/operStateEnum";

/**Сервис проведения операций */
@injectable()
export default class SbpDefaultOutService extends BaseOperationService {
  constructor(
    @inject(DiTokens.AlertService) public alertService: IAlertService,
    @inject(DiTokens.ErrorService) public errorService: IErrorService
  ) {
    super(alertService, errorService);
  }

  public PersonStore!: PersonStore;

  /**
   * Инициализация операции
   * @param initData Данные для инициализации
   * */
  public async init(
    configStore: ConfigStore,
    personStore: PersonStore
  ): Promise<SbpDefaultOutModel> {
    this.PersonStore = personStore;
    const operationData = new SbpDefaultOutModel(personStore.personInfo);
    operationData.RespondentCode =
      configStore.apiData.OperationCodeOfSetDefaultOutAccount;
    return operationData;
  }

  /**
   * Следующий шаг операции
   */
  public async nextStep(model: SbpDefaultOutModel): Promise<SbpDefaultOutModel> {
    if (model.checkProperties()) {
      if (model.IsInit) {
        model = await this.execute(model);
      }
    }
    return model;
  }

  /**
   * Обработка execute
   */
  public async execute(model: SbpDefaultOutModel): Promise<SbpDefaultOutModel> {
    try {
      model.ActionStateText = "";
      let ord: OperationRequestData = await model.createOperationRequest();
      ord.verificationCode = model.VerifyCode;
      ord.operationId = model.OperationId;
      ord = await OperationsApi.executeOperationSendAsync(ord);
      model.RequestState = ord.requestState;
      model = await this.analyzeState(model, ord);
    } catch (e) {
      if (
        e.message.indexOf("Пароль введен неверно") ||
        e.message.indexOf("Технические проблемы")
      ) {
        model.TryCount--;
      }
      model.ActionStateText = e.message;
      await this.errorService.errorHandler(e, false, true, "");
    }
    return model;
  }

  /**
   * Действия после проведения операции
   */
  public async afterExecute(model: SbpDefaultOutModel): Promise<void> {
    this.alertService.success(
      i18n.t(`main.settings.messages.accountOutDefaultExecuted`).toString()
    );
    this.PersonStore.personInfo.Data.DefaultOutAccount = model.accountOut.Data?.ReferenceId;
  }

  /**Вычисляем статус операции после выполнения */
  public async analyzeState(
    model: SbpDefaultOutModel,
    ord: OperationRequestData
  ): Promise<SbpDefaultOutModel> {
    model._actionState =
      ord.requestState == RequestsStates.Executed ||
      ord.requestState == RequestsStates.None
        ? ActionStateEnum.Success
        : [3, 6, 7].indexOf(ord.requestState as number)
        ? ActionStateEnum.Error
        : ActionStateEnum.Executing;
    model.ActionStateText = ord.requestStateDescription;
    return model;
  }
}
